"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAndParseMessage = void 0;
/**
 * Extracts payload from websocket 'message' event then json parses the value, from either a websocket MessageEvent (evt.data)
 *  or the message as a string.
 *
 * The WebSocket event listeners pass a MessageEvent (with the payload on evt.data) but some higher-level libs do the json
 *   parsing themselves. This makes some checks to handle either case.
 *
 * @param rawMsg
 */
function extractAndParseMessage(rawMsg) {
    if (!rawMsg) {
        return;
    }
    let msg;
    if (rawMsg && typeof rawMsg === 'object' && rawMsg.data) { // hasOwnProperty('data')
        msg = rawMsg.data;
    }
    else {
        msg = rawMsg; // do any of the other WebSocket.Data types need special handling? (Buffer should parse ok, but what about Buffer[]? )
    }
    if (msg && typeof msg === 'string') {
        return JSON.parse(msg);
    }
    else {
        return msg;
    }
}
exports.extractAndParseMessage = extractAndParseMessage;
//# sourceMappingURL=extract-and-parse-message.js.map